import * as React from 'react';

import EnterpriseBffSpecializationContext, {
  useEnterpriseSpecializationPageData,
  useIsEnterpriseS12nDataLoading,
} from 'bundles/unified-description-page-common/contexts/enterprise/EnterpriseBffSpecializationContext';
import withGoogleIndiaOverrides from 'bundles/unified-description-page-common/hocs/withGoogleIndiaOverrides';
import type { PropsToComponent as PropsToInnerComponent } from 'bundles/unified-description-page-common/hocs/withGoogleIndiaOverrides';
import type { EnterpriseSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseSpecializationPageQuery';

// Due to use of EnterpriseBffSpecializationContext data, this must be wrapped by the EnterpriseBffSpecializationDataProvider.
const EnterpriseGoogleIndiaOverridesDataProvider = ({ overrides, children }: PropsToInnerComponent) => {
  const pageData = useEnterpriseSpecializationPageData();
  const isS12nDataLoading = useIsEnterpriseS12nDataLoading();

  const enterpriseSpecializationPageDataWithOverrides = overrides
    ? ({
        ...pageData,
        description: overrides.description,
        cmlDescription: overrides.cmlDescription,
        faqs: overrides.faqs,
      } as EnterpriseSpecializationPageFieldsFragment)
    : pageData;

  return (
    <EnterpriseBffSpecializationContext.Provider
      value={{ specializationPage: enterpriseSpecializationPageDataWithOverrides, isS12nDataLoading }}
    >
      {children}
    </EnterpriseBffSpecializationContext.Provider>
  );
};

export default withGoogleIndiaOverrides(EnterpriseGoogleIndiaOverridesDataProvider);
